export default __webpack_public_path__ + "static/media/apartment-8344f2204f889617bae628dce334f9fb.png";